import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenusService } from 'src/app/services/menus.service';
import { Menu } from 'src/app/interfaces/menus.interface';
import { fromEvent, Subscription } from 'rxjs';
import { NgbTabsetConfig } from '@ng-bootstrap/ng-bootstrap';
import { SingleMenu } from 'src/app/interfaces/singlemenu.interface';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, DocumentChangeAction } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { CheckoutService } from 'src/app/services/checkout.service';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, pluck, map } from 'rxjs/operators';
import { FilterdMenuObj } from 'src/app/interfaces/filterd-menu-obj';


@Component({
  selector: 'app-quickmenu',
  templateUrl: './quickmenu.component.html',
  styleUrls: ['./quickmenu.component.scss'],
  providers: [NgbTabsetConfig] // add NgbTabsetConfig to the component providers
})
export class QuickmenuComponent implements OnInit,OnDestroy {

  // load: boolean = true;

  add:number = -1

  menu: Menu[] = []

  singlemenu: SingleMenu[] = []

  menuObservable:Subscription;

  singlemenuObservable:Subscription;
  
  linkRef: AngularFirestoreCollection<any>;

  link: Observable< DocumentChangeAction<unknown> [] >

  constructor(config: NgbTabsetConfig,
                private menusS: MenusService,
                private fs: AngularFirestore,
                private order:CartService,
                private checkuser:AuthService,
                private router:Router,
                private checkout:CheckoutService,
                private translate:TranslateService) {
    // customize default values of tabsets used by this component tree
    config.justify = 'center';
    config.type = 'pills';
  }

  title_ar:boolean = true
  title_en:boolean = false
  description_ar:boolean = true
  description_en:boolean = false

  filtered: FilterdMenuObj[]=[]
  
  string:string =''
  
  please_select_again:boolean = false

  ngOnInit() {
   
    const input = document.getElementById('input')
   
    const fromevent = fromEvent(input, 'keyup')
   
    const pluckk = fromevent.pipe(pluck('target','value'),debounceTime(1000) )
    
    pluckk.subscribe((value:string) =>{
  
      this.limit = 100
      
        this.showMoreBtn = false

        if(this.translate.currentLang == "en") {
          this.filtered = this.singlemenu.filter(dish => dish.title.indexOf(value.toUpperCase()) !== -1)
        }
        
        else if(this.translate.currentLang == "ar") {
          this.filtered = this.singlemenu.filter(dish => dish.title_ar.indexOf(value) !== -1)
        }
      
      // this.filtered = this.singlemenu.filter(dish => dish.title_ar.indexOf(value) !== -1)
        
      // this.filtered = this.singlemenu.filter(dish => dish.title.indexOf(value.toUpperCase()) !== -1)
      
      this.singlemenu = this.filtered
      
      console.log(value)
      
      console.log(this.filtered)
      
      if(value == ''){

        this.limit = 12
        
        this.linkRef = this.fs.collection('menus').doc(this.id).collection('singlemenu', ref => ref.orderBy('title_ar','desc').limit(this.limit))

        this.link = this.linkRef.snapshotChanges();
  
        this.singlemenuObservable = this.link.subscribe(data => {
          this.singlemenu = data.map(element => {
            return {
              id:element.payload.doc.id,
              ...element.payload.doc.data() as {},
            }
          })
        })
        this.showMoreBtn = true
      }
      if(this.filtered.length == 0) {
        this.showMoreBtn = false
        this.please_select_again = true
        setTimeout(() => {
          this.please_select_again = false
          this.showMoreBtn = true
          this.limit = 12
          this.linkRef = this.fs.collection('menus').doc(this.id).collection('singlemenu', ref => ref.orderBy('title_ar','desc').limit(this.limit))

          this.link = this.linkRef.snapshotChanges();
    
          this.singlemenuObservable = this.link.subscribe(data => {
            this.singlemenu = data.map(element => {
              return {
                id:element.payload.doc.id,
                ...element.payload.doc.data() as {},
              }
            })
          })
        }, 6000);
      }

    })
    
     this.menuObservable = this.menusS.getMenus().subscribe(data => { 
        this.menu = data.map(element => {
          return {
            id:element.payload.doc.id,
            ...element.payload.doc.data() as {},
          }
        })
     })
    
     this.translate.onLangChange.subscribe( ()=> {
      if(this.translate.currentLang == "en") {
        this.description_ar = false
        this.description_en = true
        this.title_ar = false
        this.title_en = true
      }
      else if(this.translate.currentLang == "ar") {
        this.description_ar = true
        this.description_en = false
        this.title_ar = true
        this.title_en = false
      }
    })
}

    limit:number =12

    showMoreBtn:boolean = false

    id:string = null

    dataLength:number = null

    showMore() {
      
      this.limit +=12
      
      console.log("LENGHT = ",this.dataLength, "LIMIT = ", this.limit)

      this.linkRef = this.fs.collection('menus').doc(this.id).collection('singlemenu', ref => ref.orderBy('title_ar','desc').limit(this.limit))

      this.link = this.linkRef.snapshotChanges();

      this.singlemenuObservable = this.link.subscribe(data => {
        this.singlemenu = data.map(element => {
          return {
            id:element.payload.doc.id,
            ...element.payload.doc.data() as {},
          }
        })
      })
      
      let restToShow = this.dataLength - this.limit

      console.log("REST TO SHOW = ", restToShow)
      
      if(restToShow <= 0) {
      
        this.showMoreBtn = false
      
      }
    }

    sub(id) {
      
      document.getElementById('search_bar').style.display="flex";
      
      this.please_select_again = false

      this.id = id

      this.showMoreBtn = true
    
      this.linkRef = this.fs.collection('menus').doc(this.id).collection('singlemenu')

      this.link = this.linkRef.valueChanges();

      this.singlemenuObservable = this.link.subscribe(data => {
      
        this.dataLength = data.length

        console.log("DATA'S LENGTH = ",this.dataLength)
      })
      
      this.linkRef = this.fs.collection('menus').doc(id).collection('singlemenu', ref => ref.orderBy('title_ar','desc').limit(this.limit))
    
      this.link = this.linkRef.snapshotChanges();

      this.singlemenuObservable = this.link.subscribe(data => {
        this.singlemenu = data.map(element => {
          return {
            id:element.payload.doc.id,
            ...element.payload.doc.data() as {},
          }
        })
        console.log("DATA'S LENGTH = ",data.length)
      })

      document.getElementById('choose').style.display="none";
      document.getElementById('arrow').style.display="none";
      document.getElementById('container').classList.remove('cont')
    
    }

    

  addtocart(index:number){
    
    if(this.checkout.orderSubInfoLength !=0 ){
     
      this.router.navigate(['/checkout-guard'])
    
    }
    this.checkuser.user.subscribe(user=> {

      if(user)  this.add = +index

      else this.router.navigate(['/login'])

    })
  }
  
  done:boolean = false

  buy(amount:number){
    let selectedDish = this.singlemenu[this.add]
    let data = {
      title: selectedDish.title,
      title_ar: selectedDish.title_ar,
      amount: +amount,
      price: +selectedDish.price,
      photo: selectedDish.photoUrl
    }
    this.order.addToOrder(data)
    .then(()=> {
      this.add = -1
      this.done = true
      setTimeout(()=>{
        this.done = false
      }, 5000);
    })
  }
  ngOnDestroy() {
    this.menuObservable.unsubscribe();
    // this.singlemenuObservable.unsubscribe();
  }

}
